import { render } from "./product-details-drawer.vue?vue&type=template&id=2c9f0a66"
import script from "./product-details-drawer.vue?vue&type=script&lang=js"
export * from "./product-details-drawer.vue?vue&type=script&lang=js"

import "./product-details-drawer.vue?vue&type=style&index=0&id=2c9f0a66&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__